var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            _vm._l(_vm.itineraryItems, function (item, index) {
              return _c(
                "v-card",
                {
                  key: index,
                  staticClass: "trip-itinerary-item mb-4 pa-4",
                  attrs: { outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "", align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "2" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Day Range",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.itineraryItems[index].day_range,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.itineraryItems[index],
                                  "day_range",
                                  $$v
                                )
                              },
                              expression: "itineraryItems[index].day_range",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Subtitle",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.itineraryItems[index].subtitle,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.itineraryItems[index],
                                  "subtitle",
                                  $$v
                                )
                              },
                              expression: "itineraryItems[index].subtitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "1" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                title: _vm.expandedItems[index]
                                  ? "Collapse"
                                  : "Expand",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleExpanded(index)
                                },
                              },
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  _vm._s(
                                    _vm.expandedItems[index]
                                      ? "expand_less"
                                      : "expand_more"
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", sm: "3" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                title: "Move up",
                                disabled: index === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveUp(index)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("arrow_upward")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                title: "Move down",
                                disabled:
                                  index === _vm.itineraryItems.length - 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveDown(index)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("arrow_downward")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ies-coral--text",
                              attrs: { icon: "", small: "", title: "Delete" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(index)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("delete")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-expand-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.expandedItems[index],
                            expression: "expandedItems[index]",
                          },
                        ],
                        staticClass: "mt-3",
                      },
                      [
                        _c(
                          "v-row",
                          { staticClass: "mb-3", attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    label: "Location",
                                    "hide-details": "",
                                    outlined: "",
                                    dense: "",
                                    clearable: "",
                                    items: _vm.locations,
                                    "item-text": "name",
                                    "item-value": "location_key",
                                  },
                                  model: {
                                    value:
                                      _vm.itineraryItems[index].location_key,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.itineraryItems[index],
                                        "location_key",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "itineraryItems[index].location_key",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    label: "Hotel",
                                    "hide-details": "",
                                    outlined: "",
                                    dense: "",
                                    clearable: "",
                                    items: _vm.hotels,
                                    "item-text": "display",
                                    "item-value": "hotel_key",
                                  },
                                  model: {
                                    value: _vm.itineraryItems[index].hotel_key,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.itineraryItems[index],
                                        "hotel_key",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "itineraryItems[index].hotel_key",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Transport & Duration",
                                    "hide-details": "",
                                    outlined: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.itineraryItems[index].transport,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.itineraryItems[index],
                                        "transport",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "itineraryItems[index].transport",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("tinymce", {
                                  attrs: {
                                    id: "tinymce_trip_itinerary_item_" + index,
                                    init: _vm.tinymceConfiguration.init,
                                  },
                                  model: {
                                    value:
                                      _vm.itineraryItems[index].description,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.itineraryItems[index],
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "itineraryItems[index].description",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          { staticClass: "mb-3", attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("ies-image", {
                                  attrs: { field: _vm.imageFields[index] },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "text-right",
              attrs: { cols: "12", sm: "3", "offset-sm": "9" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ies-green",
                  attrs: { title: "Add Item" },
                  on: {
                    click: function ($event) {
                      return _vm.addItem()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: this.field.fieldName },
            domProps: { value: _vm.field.value },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }